import CustomDropdown from '../reusable/dropdown';
import { CustomerObject } from '../../params/redux/customer';
import CustomInput from '../reusable/input';
import { fetchCustomerIntegrationsThunk } from '../../redux/thunks/integration';
import { settingSelectedCustomer } from '../../redux/slices/customer';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, InputAdornment, Menu, MenuItem, SelectChangeEvent, Typography } from '@mui/material';
import { CalendarMonthOutlined, Search, Sort } from '@mui/icons-material';
import { settingAddingGoogleEvent, settingAddingGoogleMeeting, settingAvailabilityFlag } from '../../redux/slices/calendar';
import { useDispatch, useSelector } from 'react-redux';

interface TabsHeaderProps {
    isOverView?: boolean
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    sort: boolean;
    setSort: (sort: boolean) => void;
    notToShow?: boolean
}

const TabsHeader = ({ isOverView = false, searchQuery, setSearchQuery, sort, setSort, notToShow = true }: TabsHeaderProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams<{ id: string }>();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const { customers, selectedCustomer, loaders } = useSelector((state: RootState) => state.customer);
    const { events } = useSelector((state: RootState) => state.calendar);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { integrations } = useSelector((state: RootState) => state.integration);
    const open = Boolean(anchorEl);

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMeetingLink = () => {
        dispatch(settingAddingGoogleEvent(true));
        dispatch(settingAddingGoogleMeeting(false));
    };

    const handlerMeeting = () => {
        dispatch(settingAddingGoogleMeeting(true));
        dispatch(settingAddingGoogleEvent(false));
    };

    const handleChangeUser = async (event: SelectChangeEvent<unknown>) => {
        event.preventDefault();
        try {
            const selectedCus = customers.find((cus: CustomerObject) => cus.id === event.target.value as number);
            dispatch(settingSelectedCustomer(selectedCus));
            await dispatch(fetchCustomerIntegrationsThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
        } catch (e) {
            //
        }
    };

    const handleAvailability = () => {
        dispatch(settingAvailabilityFlag(true));
    };

    // const isCalendarOrMeetAvailable = integrations.includes('calendar') || integrations.includes('meet');
    // const isCalendarOrMeetAvailable = integrations.includes('calendar');
    const disabledButtonsForClientSide = (currentUser?.role === 'organizationAdmin' || currentUser?.role === 'organizationOwner') && ((location.pathname.includes('/app/client/') || !location.pathname.includes('/app/calendar')) && !selectedCustomer);

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1} mb={2}>
            <Box display="flex" alignItems="center" gap={2}>
                {
                    isOverView
                        ? <Typography variant="h5" color="textSecondary">Calendar</Typography>
                        : <CustomInput
                            placeholder="Search..."
                            value={searchQuery}
                            fullWidth
                            slotProps={{
                                input: {
                                    startAdornment: <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                }
                            }}
                            onChange={(e) => setSearchQuery(e.target.value)} />}
                {notToShow && <Button startIcon={<Sort />} onClick={() => setSort(!sort)} variant="outlined" color={sort ? 'primary' : 'secondary'}>Sort</Button>}
                {location.pathname.includes('/app/client') && (currentUser?.role === 'organizationOwner' || currentUser?.role === 'organizationAdmin') && <Box>
                    <CustomDropdown
                        options={customers.map((cust: CustomerObject) => ({
                            label: `${cust.first_name} ${cust.last_name}`,
                            value: cust.id
                        }))}
                        onChange={handleChangeUser}
                        error={false}
                        placeholder="Select a customer"
                        value={selectedCustomer?.id || ''}
                        disabled={loaders.isLoading}
                        sx={{
                            mb: 0
                        }}
                    />
                </Box>}
                {
                    (!integrations.includes('calendar')) && <Typography variant="body1" color="error" minWidth="400px">User have not integrated Calendar.</Typography>
                }
                <Box>
                    {events.length === 0 && <Typography variant="body1" color="textDisabled">{selectedCustomer?.name}</Typography>}
                </Box>
            </Box>
            <Box display="flex" gap="15px">
                <Button variant="outlined" disabled={disabledButtonsForClientSide} onClick={handleAvailability} >Set Availability</Button>
                <Button variant="contained" disabled={disabledButtonsForClientSide} onClick={handleButtonClick} ><Box display="flex" alignItems="center" gap="10px"><CalendarMonthOutlined /> Create an event</Box></Button>
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => setAnchorEl(null)}
                    MenuListProps={{
                        'aria-labelledby': 'add-pipeline-button'
                    }}
                >
                    <MenuItem disabled={disabledButtonsForClientSide} onClick={handleMeetingLink}>
                        Calendar Link
                    </MenuItem>
                    <MenuItem disabled={disabledButtonsForClientSide} onClick={handlerMeeting}>
                        Meeting
                    </MenuItem>
                </Menu>
            </Box>
        </Box>
    );
};

export default TabsHeader;